// extracted by mini-css-extract-plugin
export default {"lds":"LoadingSpinner_lds__JJwJb"};